function scrollToElem(scrollTo) {
    if (!scrollTo) return;

    Velocity(scrollTo, 'scroll', {
        duration: Math.min(Math.pow(10000 / window.scrollY, 1.05) * 400, 2000),
        offset: -(checkWidth(768) ? document.getElementById('nav-wrap').offsetHeight : 140)
    });
}

document.querySelectorAll('a[href*="#"]').forEach(item => {
    item.addEventListener('click', function (e) {
        if (this.tagName === 'A') e.preventDefault();

        try {
            const url = new URL(this.href);
            const hash = url.hash;

            if (!hash || hash === '#') return;

            const targetElem = document.querySelector(hash);
            if (targetElem) {
                scrollToElem(targetElem);
            }
        } catch (err) {
            console.warn('Invalid URL in href:', this.href);
        }
    });
});

/*==============================
=           Insurance          =
==============================*/
// Vanilla JS count up animation from:
// https://jshakespeare.com/simple-count-up-number-animation-javascript-react/

// How long you want the animation to take, in ms
const animationDuration = 2000;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round( animationDuration / frameDuration );
// An ease-out function that slows the count as it progresses
const easeOutQuad = t => t * ( 2 - t );

// The animation function, which takes an Element
const animateCountUp = el => {
    let frame = 0;
    const countTo = parseInt(el.innerHTML);
    // Start the animation running 60 times per second
    const counter = setInterval( () => {
        frame++;
        // Calculate our progress as a value between 0 and 1
        // Pass that value to our easing function to get our
        // progress on a curve
        const progress = easeOutQuad( frame / totalFrames );
        // Use the progress value to calculate the current count
        const currentCount = Math.round( countTo * progress );

        // If the current count has changed, update the element
        if ( parseInt(el.innerHTML) !== currentCount ) {
            el.innerHTML = currentCount;
        }

        // If we’ve reached our last frame, stop the animation
        if ( frame === totalFrames ) {
            clearInterval( counter );
        }
    }, frameDuration );
};

if(document.querySelector('#insurance-center, #insurance-center-mlp')) {
    var ran = false;
    var insuranceSection = document.querySelector('#insurance-center, #insurance-center-mlp');
    var numberElement = insuranceSection.querySelector('h2 > u');
    var trustlogosWaypoint = new Waypoint({
        element: insuranceSection,
        handler: function(direction) {
            if(direction == 'down' && !ran) {
                animateCountUp(numberElement);
                ran = true;
            }
        },
        offset: checkWidth(480) && window.innerHeight > 552 ? '80%' : '95%'
    });
}

if (
  (document.body.classList.contains('desktop') &&
  document.body.classList.contains('landing') &&
  document.body.id.endsWith('-learn-more')) ||
  (document.body.classList.contains('mobile') &&
  document.body.classList.contains('landing') &&
  document.body.id.endsWith('-learn-more'))
) {
  const navCTA = document.querySelector('#nav-wrap .button');
  const navPhone = document.querySelector('#nav-phone');
  const triggerOffset = 1;

  navCTA.style.display = 'none';
  if (navPhone) {
    navPhone.style.display = 'none';
    navPhone.style.opacity = 0;
  }

  const onScroll = () => {
    const scrolled = window.scrollY > triggerOffset;

    if (scrolled) {
      navCTA.style.display = '';
      if (navPhone) {
        navPhone.style.display = '';
        navPhone.style.opacity = 1;
      }
    } else {
      navCTA.style.display = 'none';
      if (navPhone) {
        navPhone.style.display = 'none';
        navPhone.style.opacity = 0;
      }
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
};

if((document.querySelector('body.desktop.landing') &&
  !document.body.id.endsWith('-learn-more')) ||
  (document.querySelector('body.mobile.landing') &&
  !document.body.id.endsWith('-learn-more'))) {
    var main = document.querySelector('main');
    var navCTA = document.querySelector('#nav-wrap .button');
    var navPhone = document.querySelector('#nav-phone');
    var navCTAWaypoint = new Waypoint({
        element: main,
        handler: function(direction) {
            if(direction == 'down') {
                if (navPhone) {
                    navCTA.style.opacity = navPhone.style.opacity = 1;
                    navCTA.style.pointerEvents = navPhone.style.pointerEvents = 'initial';
                } else {
                    navCTA.style.opacity = 1;
                    navCTA.style.pointerEvents = 'initial';
                }
            } else if(direction == 'up') {
                if (navPhone) {
                    navCTA.style.opacity = navPhone.style.opacity = 0;
                    navCTA.style.pointerEvents = navPhone.style.pointerEvents = 'none';
                } else {
                    navCTA.style.opacity = 0;
                    navCTA.style.pointerEvents = 'initial';
                }
            }
        },
        offset: 225
    });
}

// Fix footer checkbox
var footer_nl_signup_label = document.querySelector('#footer-form [for="nl_signup"], .book_form [for="nl_signup"]'),
    footer_nl_signup = document.querySelector('#footer-form #nl_signup, .book_form #nl_signup');

if(footer_nl_signup_label) {
    footer_nl_signup_label.setAttribute('for', 'footer_nl_signup');
}

if(footer_nl_signup) {
    footer_nl_signup.setAttribute('id', 'footer_nl_signup');
}
